// Centralized feature flags (CRA: env vars must start with REACT_APP_)

const normalize = (v: string) => v.trim().toLowerCase();

export function readBooleanFlag(
  envValue: string | undefined,
  defaultValue: boolean
): boolean {
  if (envValue === undefined) return defaultValue;
  const v = normalize(envValue);
  if (v === "1" || v === "true" || v === "yes" || v === "on") return true;
  if (v === "0" || v === "false" || v === "no" || v === "off") return false;
  return defaultValue;
}

/**
 * Controls Battery metric for CLUSTERS only (map, cluster cards, cluster sorting/filtering).
 * Battery stays enabled for TECHNOLOGIES (tech cards and tech lists).
 */
export const FEATURE_CLUSTER_BATTERY_METRIC_ENABLED = readBooleanFlag(
  process.env.REACT_APP_FEATURE_CLUSTER_BATTERY_METRIC_ENABLED,
  true
);

// Backwards-compat alias (deprecated): previously this flag was global.
// Keep it so older envs don't break builds; do NOT use in new code.
export const FEATURE_BATTERY_METRIC_ENABLED =
  FEATURE_CLUSTER_BATTERY_METRIC_ENABLED;


